export const brand = {
  shortName: "闪影星云",
  fullName: "闪影星云文化传媒有限公司",
  englishName: "SHANYING NEBULA",
  descriptor: "CULTURE & MEDIA",
  statement: "让每一次闪耀，都成为引力。",
  email: "j12685486@gmail.com",
  phone: "15529388574",
  location: "中国 · CHINA",
};

export const navigation = [
  {
    id: "top",
    label: "首页",
    english: "Home",
    index: "00",
    href: "index.html",
    page: "home",
  },
  {
    id: "about",
    label: "我们是谁",
    english: "Studio",
    index: "01",
    href: "about.html",
    page: "about",
  },
  {
    id: "work",
    label: "代表项目",
    english: "Work",
    index: "02",
    href: "work.html",
    page: "work",
  },
  {
    id: "capabilities",
    label: "服务能力",
    english: "Capabilities",
    index: "03",
    href: "services.html",
    page: "services",
  },
  {
    id: "contact",
    label: "联系合作",
    english: "Contact",
    index: "04",
    href: "contact.html",
    page: "contact",
  },
];

export const heroDisciplines = ["STRATEGY", "FILM", "EXPERIENCE"];

export const reelClips = [
  {
    index: "REEL / 01",
    title: "旷野奔马",
    note: "高原日落与群马奔行",
    duration: "00:15",
    src: "video/reel-horse.mp4",
    poster: "image/reel-horse.webp",
  },
  {
    index: "REEL / 02",
    title: "花间微距",
    note: "花瓣、昆虫与自然细节",
    duration: "00:12",
    src: "video/reel-flower.mp4",
    poster: "image/reel-flower.webp",
  },
  {
    index: "REEL / 03",
    title: "雪线暮色",
    note: "雪山光线的短暂变化",
    duration: "00:05",
    src: "video/reel-mountain.mp4",
    poster: "image/reel-mountain.webp",
  },
  {
    index: "REEL / 04",
    title: "银河横贯",
    note: "高原夜空与银河全景",
    duration: "00:04",
    src: "video/reel-galaxy.mp4",
    poster: "image/reel-galaxy.webp",
  },
];

export const cases = [
  {
    number: "CASE / 01",
    category: "品牌影像",
    title: "把一个品牌的野心，拍成观众愿意记住的画面。",
    description:
      "从核心命题、视觉母题到整片节奏，建立一套只属于品牌自己的影像语言。",
    tags: ["品牌片", "广告片", "创意制作"],
    result: "01:30",
    resultLabel: "建议主片时长",
    ratio: "16:9",
    format: "Brand Film",
    media: "image/pagoda-sunset.webp",
    alt: "日落云层与岩石溪流之间亮起灯光的塔楼",
    mediaLabel: "PAGODA / SUNSET STUDY",
  },
  {
    number: "CASE / 02",
    category: "整合传播",
    title: "让一次发布，不只被看见，还能持续生长。",
    description:
      "把内容节奏、渠道触点与话题机制放进同一张传播地图，形成连续影响力。",
    tags: ["传播策略", "社交内容", "媒介协同"],
    result: "360°",
    resultLabel: "全域内容触点",
    ratio: "4:5",
    format: "Campaign",
    media: "image/case-dining.webp",
    alt: "暖色餐桌中央摆放着完成的餐食，周围人物虚化",
    mediaLabel: "DINING / LIFESTYLE",
  },
  {
    number: "CASE / 03",
    category: "文化活动",
    title: "把现场变成故事，让离场之后仍有回声。",
    description:
      "从空间情绪、舞台内容到传播素材，为活动建立可体验、可记录、可扩散的完整叙事。",
    tags: ["活动策划", "现场视觉", "内容记录"],
    result: "LIVE",
    resultLabel: "线上线下联动",
    ratio: "16:10",
    format: "Event",
    media: "image/pagoda-blue-soft.webp",
    alt: "蓝调天空、岩石与流水之间的塔楼",
    mediaLabel: "PAGODA / BLUE HOUR",
  },
  {
    number: "CASE / 04",
    category: "数字体验",
    title: "让屏幕不再只是界面，而是一场可以进入的体验。",
    description:
      "以动态视觉、互动逻辑与空间内容，为新品、展陈和数字发布创造沉浸式触点。",
    tags: ["互动创意", "动态设计", "数字展陈"],
    result: "REAL–TIME",
    resultLabel: "实时互动反馈",
    ratio: "21:9",
    format: "Digital",
    media: "image/case-lotus.webp",
    alt: "绿色荷叶间盛开的粉色荷花",
    mediaLabel: "NATURE / VISUAL STUDY",
  },
];

export const archiveFrames = [
  {
    index: "FRAME / 01",
    title: "蓝调时刻",
    note: "夜景观察",
    src: "image/pagoda-blue-glow.webp",
    alt: "深蓝天空与岩石溪流之间亮起金色灯光的塔楼",
    layout: "archive-shot--panorama",
  },
  {
    index: "FRAME / 02",
    title: "夜航",
    note: "机坪记录",
    src: "image/archive-flight-night.webp",
    alt: "夜色山影前停放的飞行器与远处灯光",
    layout: "archive-shot--night",
  },
  {
    index: "FRAME / 03",
    title: "云层标本",
    note: "天空研究",
    src: "image/archive-clouds.webp",
    alt: "淡蓝天空中被晚霞染成粉色的流动云层",
    layout: "archive-shot--cloud",
  },
  {
    index: "FRAME / 04",
    title: "月面",
    note: "长焦观测",
    src: "image/archive-moon.webp",
    alt: "黑色背景中的月球表面与清晰环形山纹理",
    layout: "archive-shot--portrait",
  },
  {
    index: "FRAME / 05",
    title: "餐桌光线",
    note: "商业静物",
    src: "image/archive-cuisine.webp",
    alt: "浅色餐盘上的深色料理与绿色柑橘切片",
    layout: "archive-shot--still-life",
  },
  {
    index: "FRAME / 06",
    title: "起降场",
    note: "在地记录",
    src: "image/archive-field.webp",
    alt: "群山与植被之间的飞行器尾部和场地设施",
    layout: "archive-shot--field",
  },
  {
    index: "FRAME / 07",
    title: "航迹",
    note: "速度研究",
    src: "image/archive-flight.webp",
    alt: "蓝色天空中从下方掠过的彩色飞机",
    layout: "archive-shot--flight",
  },
  {
    index: "FRAME / 08",
    title: "现场发生",
    note: "文化活动",
    src: "image/archive-live.webp",
    alt: "活动现场中围绕设备交流与操作的参与者",
    layout: "archive-shot--live",
  },
  {
    index: "FRAME / 09",
    title: "校园秋光",
    note: "西工大校园记录",
    src: "image/archive-street.webp",
    alt: "西北工业大学教务部与教学运行服务中心入口前，秋日阳光洒在红墙、自行车和落叶上",
    layout: "archive-shot--street",
    particleProfile: "campus",
  },
];

export const capabilities = [
  {
    index: "01",
    short: "策略",
    title: "内容与品牌策略",
    description:
      "找到品牌真正值得被放大的部分，梳理核心叙事、受众关系与长期内容方向。",
    tags: ["品牌叙事", "内容策略", "传播规划"],
  },
  {
    index: "02",
    short: "创意",
    title: "创意概念与视觉系统",
    description:
      "把抽象价值转译为明确的视觉母题、语言风格与可持续生长的创意系统。",
    tags: ["创意企划", "视觉概念", "内容设计"],
  },
  {
    index: "03",
    short: "影像",
    title: "商业影像全案制作",
    description:
      "覆盖前期策划、导演执行、拍摄统筹、后期剪辑与动态包装，让影像完整落地。",
    tags: ["广告影像", "纪录内容", "短视频"],
  },
  {
    index: "04",
    short: "现场",
    title: "活动与空间内容",
    description:
      "用空间、舞台和现场内容建立共同体验，让活动成为品牌关系的真实发生地。",
    tags: ["活动策划", "舞台内容", "现场统筹"],
  },
  {
    index: "05",
    short: "传播",
    title: "整合传播与内容运营",
    description:
      "设计渠道节奏、内容矩阵与社交议题，让一次创意在不同媒介中持续释放能量。",
    tags: ["整合营销", "社媒内容", "传播执行"],
  },
];

export const processSteps = [
  {
    number: "PHASE / 01",
    title: "洞察",
    description:
      "先理解生意、品牌和人。把真实问题定义清楚，创意才不会只停留在表面。",
  },
  {
    number: "PHASE / 02",
    title: "定轨",
    description:
      "确认策略、创意方向、制作边界和关键节点，让项目从一开始就在同一条轨道上。",
  },
  {
    number: "PHASE / 03",
    title: "共创",
    description:
      "策划、导演、设计与制作并行推进，在每个关键节点保持透明、快速、准确。",
  },
  {
    number: "PHASE / 04",
    title: "抵达",
    description:
      "完成交付、上线与传播复盘，让内容不止完成制作，更真正抵达目标人群。",
  },
];

export const timeline = [
  {
    year: "NOW",
    title: "为品牌建立可辨认的内容引力",
    description:
      "我们以文化洞察为起点，让策略、影像、体验与传播在一个创意系统中协同发生。",
  },
  {
    year: "01",
    title: "从真实命题出发",
    description:
      "拒绝先套风格再找理由。每个项目都先回答：为什么现在要说、最想让谁相信、最后要发生什么。",
  },
  {
    year: "02",
    title: "用一个强概念统领全部触点",
    description:
      "无论是一支影片、一场活动还是一组社交内容，都围绕同一条清晰主线展开。",
  },
  {
    year: "03",
    title: "让制作服务于表达",
    description:
      "把预算花在观众真正感受得到的地方，用精确执行守住创意，不让形式盖过内容。",
  },
  {
    year: "NEXT",
    title: "让好内容继续向外生长",
    description:
      "交付不是终点。我们关注内容在真实传播环境里的反应，并寻找下一次增长的线索。",
  },
];

export const statistics = [
  {
    value: "01",
    suffix: "",
    label: "一条统一的品牌叙事",
  },
  {
    value: "04",
    suffix: "+",
    label: "策略、创意、制作、传播协同",
  },
  {
    value: "∞",
    suffix: "",
    label: "内容持续生长的可能",
  },
];

export const marqueeWords = [
  "品牌影像",
  "内容策略",
  "整合传播",
  "文化活动",
  "数字体验",
  "动态视觉",
];

export const footerGroups = [
  {
    title: "EXPLORE",
    links: navigation,
  },
  {
    title: "CONNECT",
    links: [
      {
        label: brand.phone,
        href: `tel:${brand.phone}`,
      },
      {
        label: brand.email,
        href: `mailto:${brand.email}`,
      },
      {
        label: "联系合作",
        href: "contact.html",
      },
    ],
  },
];
